export default __webpack_public_path__ + "static/media/CL11.1.3461a613.mp3";